import apiInstance from './apiInstance';

const HEARTBEAT_INTERVAL = 30000;

let sessionId = null;
let heartbeatTimer = null;

async function startSession(applicationId, applicationType) {
  stopSession();
  try {
    const res = await apiInstance.post('/sessions/start', {
      applicationId,
      applicationType
    });
    sessionId = res.data.sessionId;
    startHeartbeat();
    document.addEventListener('visibilitychange', handleVisibilityChange);
  } catch (err) {
    console.error('Failed to start session:', err.message);
  }
}

function startHeartbeat() {
  if (heartbeatTimer) return;
  sendHeartbeat();
  heartbeatTimer = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);
}

function stopHeartbeat() {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer);
    heartbeatTimer = null;
  }
}

async function sendHeartbeat() {
  if (!sessionId) return;
  try {
    await apiInstance.put(`/sessions/${sessionId}/heartbeat`);
  } catch (err) {
    console.error('Heartbeat failed:', err.message);
    stopHeartbeat();
  }
}

function handleVisibilityChange() {
  if (document.hidden) {
    stopHeartbeat();
  } else if (sessionId) {
    sendHeartbeat();
    startHeartbeat();
  }
}

function stopSession() {
  sendHeartbeat();
  stopHeartbeat();
  document.removeEventListener('visibilitychange', handleVisibilityChange);
  sessionId = null;
}

export { startSession, stopSession };
